import { IHeadLabel, ISort } from "../types/table";

const defaultFilters = {
    name: '',
    branches: null
}

const departmentOrderOptions: ISort[] = [
    {
        label: "Nome Crescente",
        direction: "asc",
        sortBy: "Name"
    },
    {
        label: "Nome Decrescente",
        direction: "desc",
        sortBy: "Name"
    },
    {
        label: "Cadastro Crescente",
        direction: 'asc',
        sortBy: 'Id'
    },
    {
        label: "Cadastro Decrescente",
        direction: 'desc',
        sortBy: 'Id'
    }
];

const columnsTable: IHeadLabel[] = [
    {
        label: "ID",
    },
    {
        label: "Nome"
    },    
    {
        label: "Cód. Filial"
    },
    {
        label: "Nome Filial"
    },
    {
        label: "Coordenador"
    },
    {
        label: "Ativo"
    },
    {
        label: "",
        align: "right"
    }
];

export {
    defaultFilters,
    departmentOrderOptions,
    columnsTable
}